export default __webpack_public_path__ + "static/media/talent_finder_export.cd5ed511.svg";